import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  input,
  output
} from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';
import { IconFlagComponent } from '../../components/icon/icon-flag.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { MarketType } from '../../domain/market.domain';
import { SymbolType } from '../../domain/symbol.domain';

@Component({
  selector: 'td-wb-ticker-symbol',
  templateUrl: 'ticker-symbol.component.html',
  styleUrls: ['ticker-symbol.component.scss'],
  imports: [
    IconFlagComponent,
    TranslatePipe,
    IconComponent,
    NgTemplateOutlet
  ],
  host: {
    '[class.td-wb-ticker-symbol--single-line]': 'singleLine()',
    '[class.td-wb-ticker-symbol--short-description]': 'shortDescription()',
    '[class.td-wb-ticker-symbol--link]': 'symbolLink()'
  }
})
export class TickerSymbolComponent {
  readonly tickerSymbol = input<string>(undefined);
  readonly market = input<MarketType>(undefined); // CA, US -> show flag; else(undef, OTHER): disregard
  readonly symbolType = input<SymbolType>(undefined);
  readonly description = input<string>(undefined); // To be displayed on the line below/after tickerSymbol, if exists
  readonly multiAssetFund = input<boolean>(undefined);
  readonly clickNotToggle = input<boolean>(false);
  readonly showAsLink = input<boolean>(true);

  readonly singleLine = input<boolean>(false);
  readonly shortDescription = input<boolean>(false);
  readonly disabled = input<boolean>(undefined);
  readonly symbolLink = input<boolean>(false);

  readonly onToggle = output<boolean>();
  readonly onClick = output<void>();

  rowExpanded: boolean = false;

  toggleExpandRow(): false {
    if (!this.disabled()) {
      if (this.clickNotToggle()) {
        // TODO: The 'emit' function requires a mandatory void argument
        this.onClick.emit();
      } else {
        this.rowExpanded = !this.rowExpanded;
        this.onToggle.emit(this.rowExpanded);
      }

    }
    return false;
  }

  // TODO: When backend returns type as OTHER for ALL mutual funds (on top movers),
  // we will be able to rewrite as: return market in [CA, US];
  // and remove the type from the @Input section
  showMarketFlag(): boolean {
    const market = this.market();
    return this.symbolType() !== SymbolType.MUTUALFUND && (market === MarketType.CA || market ===  MarketType.US);
  }

  showLink(): boolean {
    return !this.disabled() && this.showAsLink();
  }
}
